import { createAsyncThunk } from "@reduxjs/toolkit";
import { TalesSponsor } from "../../../utils/types/TalesSponsor";
import { db } from "../../../firebase/config";

export const toggleSponsorVisibility = createAsyncThunk(
  "sponsor/toggleVisibility",
  async (sponsor: TalesSponsor) => {
    try {
      const querySnapshot = await db
        .collection("sponsor")
        .where("name", "==", sponsor.name)
        .get();

      return querySnapshot.docs[0].ref.set({ ...sponsor, show: !sponsor.show });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(
        `Sponsor non ${sponsor.show ? "nascosto" : "mostrato"}, ${e.message}`,
      );
    }
  },
);
